import { ROUTES } from ".";

export const MANAGE_MASTERS_ROUTES = {
  CLEARING_PARTNER: `${ROUTES.MASTERS}/clearing-partner`,
  ADVISOR: `${ROUTES.MASTERS}/advisor`,
  ADVISOR_REPRESENTATIVE_DETAILS: `${ROUTES.MASTERS}/advisor-representative-details`,
  ADVISOR_REPRESENTATIVE_PLAN_DETAILS: `${ROUTES.MASTERS}/advisor-representative-plan-detail`,
  TRADE_PROCESS: `${ROUTES.MASTERS}/trade-process`,
  INVESTMENTS: `${ROUTES.MASTERS}/investments`,
  CLEARING_PARTNER_DETAILS: `${ROUTES.MASTERS}/clearing-partner-details`,
  CLEARING_PARTNER__ACCOUNT_PLAN_DETAILS: `${ROUTES.MASTERS}/clearing-partner-account-plan-details`,
};
export const REVIEW_SCREEN_DATA_MAPPING = {
  CLEARING_PARTNER: `clearing-partner`,
  ADVISOR: `advisor`,
  TRADE_PROCESS: `trade-process`,
  INVESTMENTS: `investments`,
};

export const MANAGE_MASTERS_MENU = [
  {
    id: REVIEW_SCREEN_DATA_MAPPING.CLEARING_PARTNER,
    label: "Clearing Partner",
    path: MANAGE_MASTERS_ROUTES.CLEARING_PARTNER,
    contentHeader: "Clearing Partner",
    breadCrumbs: [],
    childRoutes: [
      MANAGE_MASTERS_ROUTES.CLEARING_PARTNER_DETAILS,
      MANAGE_MASTERS_ROUTES.CLEARING_PARTNER__ACCOUNT_PLAN_DETAILS,
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.ADVISOR,
    label: "Advisor",
    path: MANAGE_MASTERS_ROUTES.ADVISOR,
    contentHeader: "Advisor",
    breadCrumbs: [],
    childRoutes: [
      MANAGE_MASTERS_ROUTES.ADVISOR_REPRESENTATIVE_DETAILS,
      MANAGE_MASTERS_ROUTES.ADVISOR_REPRESENTATIVE_PLAN_DETAILS,
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.TRADE_PROCESS,
    label: "Trade Process",
    path: MANAGE_MASTERS_ROUTES.TRADE_PROCESS,
    contentHeader: "Trade Process",
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.INVESTMENTS,
    label: "Investments",
    path: MANAGE_MASTERS_ROUTES.INVESTMENTS,
    contentHeader: "Investments",
    breadCrumbs: [],
    childRoutes: [],
  },
];

export const ALL_MANAGE_MASTER_ROUTES = [...MANAGE_MASTERS_MENU];
